import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicantInformationDetails from './ApplicationInformationDetails';
import Attachments from './Attachments';
import EconomicOverview from './EconomicOverview';
import FinancialInformation from './FinancialInformation';
import ProjectOverview from './ProjectOverview';

export const BFIPApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <ApplicantInformationDetails step1={applicationData?.step1} />
      <FinancialInformation step2={applicationData?.step2} />
      <ProjectOverview step3={applicationData?.step3} />
      <EconomicOverview step4={applicationData?.step4} />
      <Attachments step5={applicationData?.step5} files={files} />
    </>
  );
};
